import * as xinjsui from './index'
import * as xinjs from 'xinjs'

console.log('foobar')
Object.assign(globalThis, { xinjs, xinjsui })
